import React from 'react';
import './App.scss';
import {Route, Routes, BrowserRouter as Router} from 'react-router-dom';
import Home from './pages/home/Home';
import ThankYou from './pages/thank-you/Thank-you';
import Landing from './pages/landing/Landing';
import Questionnaire from './pages/questionnaire/Questionnaire';
import SectionTransition from './pages/section-transition/SectionTransition';
import LeaveNote from './pages/leave-note/LeaveNote';

function App() {
  return (
    <div className="App">
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/questionnaire/:mode" element={<Questionnaire />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/section-transition" element={<SectionTransition />} />
          <Route path="/leave-note" element={<LeaveNote />} />
          <Route path="/thank-you-page" element={<ThankYou />} />
          <Route path="/landing-page/:mode" element={<Landing />} />
          <Route path="/landing-page" element={<Landing />} />
        </Routes>
      </Router>
  </div>
  );
}

export default App;
